export default "__VITE_ASSET__BZehJIMC__"